export default __webpack_public_path__ + "static/media/school.0406a4f6.jpg";